$(function () {
  $(document).on('click', '.add-favorite', function () {
    const _token = $('meta[name=csrf_token]').attr('content');
    const newsletter_id = parseInt($(this).data('id'));
    var _this = $(this);

    $.ajax({
      type: 'POST',
      url: '/tin-da-luu/store',
      data: { _token: _token, newsletter_id: newsletter_id },
      dataType: 'json',
    })
      .done(function (res) {
        if (res.status == 2) {
          toast('success', 'Thêm vào danh sách tin đã lưu thành công.');
          _this.find('.bi').removeClass('bi-heart').addClass('bi-heart-fill');
          var header_favorite = $('.header-favorite');
          if (header_favorite.length > 0) {
            header_favorite.find('span').text(res.count);
          }
        } else if (res.status == 1) {
          toast('success', 'Xóa khỏi danh sách tin đã lưu thành công.');
          _this.find('.bi').removeClass('bi-heart-fill').addClass('bi-heart');
          var header_favorite = $('.header-favorite');
          if (header_favorite.length > 0) {
            header_favorite.find('span').text(res.count);
          }
        } else if (res.status == -2) {
          toast('danger', 'Tin đã lưu chỉ được chứa tối đa 10 tin.');
        } else {
          toast('danger', 'Không thể thực hiện lúc này. Vui lòng thử lại sau.');
        }
      })
      .fail(function (err) {
        toast('danger', 'Không thể thực hiện lúc này. Vui lòng thử lại sau.');
      })
      .always(function () {
        //
      });
  });
});
